import { Expr } from "../../Expr";

export interface IEqualsXpr {
  $type: "iequals";
  instance: Expr;
  arg: Expr;
}

export const iequalsExpr = (instance: Expr, arg: Expr): IEqualsXpr => ({
  $type: "iequals",
  instance,
  arg,
});
